import { Field as BaseField } from 'components/Wizards/Field/Field'
import { Select } from 'components/Select/Select'
import { Item } from '@react-stately/collections'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './YoutubePostDetails.module.scss'
import { YOUTUBE_CATEGORIES } from './constants'
import { YoutubePostSettings } from 'api/clients/ScheduledPostsClient'

type YoutubeCategorySectionProps = {
  category: YoutubePostSettings['category']
  handleUpdateCategory: (key: React.Key) => void
}

export const YoutubeCategorySection = ({ category, handleUpdateCategory }: YoutubeCategorySectionProps) => {
  const sortedCategories = YOUTUBE_CATEGORIES.items.sort((a, b) => a.snippet.title.localeCompare(b.snippet.title))

  return (
    <div className={Styles.categoryContainer}>
      <BaseField label="Category" fieldGap={5} />
      <div className={Styles.description}>
        <Text variant="secondary">Add your video to a category so viewers can find it more easily</Text>
      </div>
      <div className={Styles.categoryList}>
        <Select
          variant="secondary"
          selectedKey={category?.id}
          onSelectionChange={handleUpdateCategory}
          useFullWidth
          useButtonWidth
          aria-label="Category selection"
          placeholder="Select a category"
          data-testid="category-select"
        >
          {sortedCategories.map((category) => (
            <Item key={category.id} textValue={category.snippet.title}>
              <div className={Styles.privacyItem}>{category.snippet.title}</div>
            </Item>
          ))}
        </Select>
      </div>
    </div>
  )
}
